import {createAction, props} from '@ngrx/store';
import {RegionCode} from '../../../services/api/account/regions/region.model';
import {InstanceType} from '../../../services/api/account/instance-types/instance-type.model';


const category = '[ProductionInstanceTypes]';

export const loadProductionInstanceTypes = createAction(
  `${category} Load Production Instance Types`,
  props<{ region: RegionCode }>()
);

export const loadProductionInstanceTypesSuccess = createAction(
  `${category} Load Production Instance Types Success`,
  props<{ data: InstanceType[] }>()
);

export const loadProductionInstanceTypesFailure = createAction(
  `${category} Load Production Instance Types Failure`,
  props<{ error: any }>()
);

export const clearProductionInstanceTypesState = createAction(
  `${category} Clear Production Instance Types State`
);
